import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import CheckoutLineItem from '../MainCheckout/CheckoutOrderSummary/CheckoutLineItem';
import OrderSummary from '../CartSummary/OrderSummary';
import './OrderConfirmationSummary.scss';

const OrderConfirmationSummary = props => {
  if (!props.response.ok) {
    return null;
  }
  return (
    <section className="order-confirmation-summary">
      <div className="container-guttered">
        <Panel className="order-confirmatation-summary__intro">
          <p className="text-kilo">{props.title}</p>
          <p>{props.description}</p>
        </Panel>
        <hr />
        {props.items && props.items.map(item => (
          <CheckoutLineItem
            key={`item-${item.id}`}
            item={item}
          />
        ))}
        {props.values &&
          <OrderSummary
            label={props.labels}
            value={props.values}
            summary={props.summary}
            showShippingPrice
          />
        }
      </div>
    </section>
  );
};

OrderConfirmationSummary.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  items: PropTypes.array,
  values: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  summary: PropTypes.object,
  response: PropTypes.shape({
    ok: PropTypes.bool,
  }).isRequired
};

export default OrderConfirmationSummary;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderConfirmationSummary/OrderConfirmationSummary.js